import { Badge } from "@/shared/ui/badge";
import { X } from "lucide-react";
import type { Tag } from "@/services/api/tags/types";

interface SelectedTagsAreaProps {
  selectedTags: Tag[];
  onRemove: (tagId: string | number) => void;
}

export function SelectedTagsArea({
  selectedTags,
  onRemove,
}: SelectedTagsAreaProps) {
  if (selectedTags.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 p-3 bg-grid-50 rounded-lg border border-grid-200">
      {selectedTags.map((tag) => (
        <Badge
          key={tag.id}
          variant="outline"
          className={`pl-2 pr-1 py-1 gap-1 flex items-center ${
            tag.color ? "" : "bg-white text-gray-800 border-gray-300"
          }`}
          style={
            tag.color
              ? {
                  backgroundColor: `${tag.color}20`,
                  color: tag.color,
                  borderColor: `${tag.color}40`,
                }
              : {}
          }
        >
          <span className="max-w-[150px] truncate">{tag.name}</span>
          <button
            type="button"
            onClick={() => onRemove(tag.id)}
            className="hover:bg-black/10 rounded-full p-0.5 transition-colors"
          >
            <X className="h-3 w-3" />
          </button>
        </Badge>
      ))}
    </div>
  );
}
